// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1Fto5","content":"LayoutSettings_content__2lZs6"};